import documentToReview from '@/components/onboarding/document-to-review/document-to-review.vue';

export default {
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
  components: {
    documentToReview,
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/document-tile-view/document-tile-view.js